import { MonetizationType, PresentationType } from '@/@types/graphql-types';
import { useLanguageStore, useSportsStore } from './useStores';
import { onMounted, onServerPrefetch } from 'vue';

interface SportPromotion {
	eventIds: string[];
	package: {
		packageId: number;
		technicalName: string;
		clearName: string;
		iconUrl: string;
	};
	monetizationType: MonetizationType;
	presentationType: PresentationType;
	standardWebURL: string;
	countries: string[];
	startDate: string;
	endDate: string;
	title: string | null;
	subtitle: string | null;
}

const nbaLeaguePassPromoEventIds = [
	'se-bkb-48094586',
	'se-bkb-48094588',
	'se-bkb-48094589',
	'se-bkb-48094591',
	'se-bkb-48094592',
	'se-bkb-48094593',
	'se-bkb-48094594',
];

const nbaLeaguePromoTitles = {
	GB: 'SIGN UP NOW',
	FR: 'ABONNEZ-VOUS DÈS À PRÉSENT',
	DE: 'JETZT ANMELDEN',
	IT: 'ISCRIVITI ORA',
	ES: 'REGÍSTRATE',
};

const nbaLeaguePromoSubtitles = {
	GB: 'STREAM THE UNFORGETTABLE',
	FR: 'VIVEZ DES MOMENTS INOUBLIABLES EN STREAMING',
	DE: 'STREAME UNVERGESSLICHE EMOTIONEN',
	IT: 'SIEDITI IN PRIMA FILA PER ASSISTERE A MOMENTI INDIMENTICABILI',
	ES: 'DISFRUTA DE MOMENTOS INOLVIDABLES',
};

function getNbaLeaguePassPromoObj(country: string): SportPromotion {
	return {
		eventIds: nbaLeaguePassPromoEventIds,
		package: {
			packageId: 1761,
			technicalName: 'nbaleaguepass',
			clearName: 'NBA League Pass',
			iconUrl: '/icon/319882438/s100/nbaleaguepass.{format}',
		},
		monetizationType: MonetizationType.Flatrate,
		presentationType: PresentationType.Hd,
		standardWebURL: 'https://prf.hn/click/camref:1100lpCRf/destination:DEEPLINK',
		countries: ['GB', 'FR', 'DE', 'IT', 'ES'],
		startDate: '2025-06-03',
		endDate: '2025-06-30',
		title: nbaLeaguePromoTitles[country as keyof typeof nbaLeaguePromoTitles],
		subtitle: nbaLeaguePromoSubtitles[country as keyof typeof nbaLeaguePromoSubtitles],
	} as SportPromotion;
}

function sportsPromotions(country: string): SportPromotion[] {
	return [getNbaLeaguePassPromoObj(country)];
}

export function getSportsPromotion() {
	const { country } = useLanguageStore();

	// Priority is determined by position in the array. The first item has the highest priority.
	const promotions = sportsPromotions(country.value).filter(promotion => {
		const currentDate = new Date();
		return (
			promotion.countries.includes(country.value) &&
			Number(currentDate) > new Date(promotion.startDate).setUTCHours(0, 0, 0, 0) &&
			Number(currentDate) < new Date(promotion.endDate).setUTCHours(23, 59, 59, 999)
			// && promotion.eventIds.includes(eventId)
		);
	});
	return { promotions };
}

export function useSportsPromotion() {
	const { setSportsPromotions, sportsPromotions } = useSportsStore();

	onServerPrefetch(async () => await setSportsPromotions());

	onMounted(async () => await setSportsPromotions());

	return { sportsPromotions };
}
